import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { consumeSessionHandoffFromHash } from './app/core/utils/session-handoff.util';

consumeSessionHandoffFromHash();

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));

